import React, { useContext, useEffect, useState } from "react";
import { Spinner } from "../../components/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faUserCheck, faUser } from "@fortawesome/free-solid-svg-icons";
import { useUnidades } from "../../hooks/test/useUnidades";
import useCeo from "../../hooks/useCEO";
import { SocketContext } from "../../context/SocketContext";

export const Staffing = () => {

    useCeo({
      title: "Módulo Staffing",
      description: "Página de staffing",
    });

    const [loading, setLoading] = useState(false);
    const [monitoristas, setMonitoristas] = useState([]);
    const [monitoristasInactivos, setMonitoristasInactivos] = useState([]);
    const [monitoristasConteo, setMonitoristasConteo] = useState([]);
    const [comidasDelDia, setcomidasDelDia] = useState([]);
    const [descansosDelDia, setdescansosDelDia] = useState([]);
    const [usuariosMas12Hrs, setusuariosMas12Hrs] = useState([]);
    const { socket } = useContext(SocketContext);

    useEffect(() => {
      if(!socket) return;
      socket.on("staffing_", () => {
        loadInfoMonitoristas();
      });
      return () => {
        socket.off('staffing_');
    }
    }, [socket]);

    useEffect(() => {
        loadInfoMonitoristas();
    }, []);

    const {
      getMonitoristas
    } = useUnidades();

    const loadInfoMonitoristas = async() => {
      setLoading(true);
      const statusMonitoristas = await getMonitoristas();
      if(statusMonitoristas.ok){
        setMonitoristasConteo(statusMonitoristas.conteo);
        setMonitoristas(statusMonitoristas.conectados);
        setMonitoristasInactivos(statusMonitoristas.inactivos);
        setcomidasDelDia(statusMonitoristas.ComidasAlDia);
        setdescansosDelDia(statusMonitoristas.DescansosAlDia);
        setusuariosMas12Hrs(statusMonitoristas.mayoresA12);
      } else {
        setMonitoristasConteo([]);
        setMonitoristas([]);
      }
      setLoading(false);
      
    }

    function secondsToString(seconds) {
      var hour = Math.floor(seconds / 3600);
      hour = (hour < 10)? '0' + hour : hour;
      var minute = Math.floor((seconds / 60) % 60);
      minute = (minute < 10)? '0' + minute : minute;
      var second = seconds % 60;
      second = (second < 10)? '0' + second : second;
      // return hour + ':' + minute + ':' + second;
      return hour + ':' + minute ;
    }
    
    console.log("loading",loading)
  
    return (
      <>
        {loading && <Spinner />}
          <div className="row">
            <div className="col-12">
              <div className="position-relative">
                <div className="position-absolute pt-5 start-50 translate-middle">
                  <h4>MONITORISTAS CONECTADOS</h4>
                </div>
              </div>
              <div id="cardMonitoristas" className="mt-5">
                <div className="card">
                  <div className="row">
                    {
                      
                      monitoristasConteo && monitoristasConteo.map((conteo)=>{
                    
                          return(
                              <>
                                <div className="card col-3">
                                  <div className="row">
                                    <div className="col-12">
                                      <i className={"M-"+conteo.estatus}>
                                        <FontAwesomeIcon icon={faCircle} />
                                        { 
                                          conteo.estatus.includes("Inicio") ?
                                          conteo.estatus.slice(7) 
                                          : conteo.estatus
                                        }
                                      </i>
                                      <i className="M-num">{ conteo.total }</i>
                                    </div>
                                  </div>
                                </div>
                              </>
                          )

                        })


                    }
                  </div>
                </div>
              </div>
              
              <div className="card">
                <div className="row">
                  <div className="card col-3" style={{ padding: "10px" }}>
                    <h5>TIEMPO EXCEDIDO COMIDAS</h5> 
                    {
                      
                      comidasDelDia && comidasDelDia.map((comidas)=>{
                    
                          return(
                              <>
                                {
                                  comidas.validacion === 1 ?
                                  <div className="row">
                                    <div className="col-8">
                                      { 
                                        <FontAwesomeIcon icon={ faUser } style={ {padding: "0px 5px 0px 0px"} } />
                                      }
                                      <i>{ comidas.nombre }</i>
                                    </div>
                                    <div className="col-4">
                                      <i>
                                        { 
                                          comidas.diferencia + " min"
                                        }
                                      </i>
                                    </div>
                                  </div>
                                  :""
                                }
                              </>
                          )
                      })
                      
                    }
                    <br/>
                    <h5>TIEMPO EXCEDIDO DESCANSOS</h5> 
                    {
                      
                      descansosDelDia && descansosDelDia.map((descansos)=>{
                    
                          return(
                              <>
                                {
                                  descansos.validacion === 1 ?
                                  <div className="row">
                                    <div className="col-8">
                                      { 
                                        <FontAwesomeIcon icon={ faUser } style={ {padding: "0px 5px 0px 0px"} } />
                                      }
                                      <i>{ descansos.nombre }</i>
                                    </div>
                                    <div className="col-4">
                                      <i>
                                        { 
                                          descansos.diferencia + " min"
                                        }
                                      </i>
                                    </div>
                                  </div>
                                  :""
                                }
                              </>
                          )
                      })
                      
                    }
                    <br/>
                    <h5>USUARIOS CON MAS DE 12 HORAS</h5> 
                    {
                      
                      usuariosMas12Hrs && usuariosMas12Hrs.map((usuarios)=>{
                    
                          return(
                              <>

                                <div className="row">
                                  <div className="col-7">
                                    { 
                                      <FontAwesomeIcon icon={ faUser } style={ {padding: "0px 5px 0px 0px"} } />
                                    }
                                    <i>{ usuarios.name }</i>
                                  </div>
                                  <div className="col-5">
                                    <i>
                                      { 
                                        secondsToString(usuarios.tiempo * 60)
                                         + " Hrs"
                                      }
                                    </i>
                                  </div>
                                </div>
                                
                              </>
                          )
                      })
                      
                    }
                  </div>
                  <div className="card col-9" style={{ padding: "10px" }}>
                    <div className="row">
                    {
                      monitoristas && monitoristas.map((persona)=>{
                      
                        return(
                            <>
                              <div className="card col-6 monitorista">
                                <div className="row">
                                  <div className="col-6">
                                    <i>{ persona.name }</i>
                                  </div>
                                  <div className="col-6">
                                    <i>
                                      { 
                                        persona.cat_tipo_registro.tipo_registro.includes("Inicio") ?
                                        persona.cat_tipo_registro.tipo_registro.slice(7) 
                                        : persona.cat_tipo_registro.tipo_registro
                                      }
                                    </i>
                                    { 
                                      <FontAwesomeIcon icon={ faUserCheck } className={ "Icon-"+persona.cat_tipo_registro.tipo_registro } />
                                    }
                                    
                                  </div>
                                </div>
                                
                              </div>
                            </>
                        )
                        
                      })
                    }
                    {
                      monitoristasInactivos && monitoristasInactivos.map((persona)=>{
                      
                        return(
                            <>
                              <div className="card col-6 monitorista">
                                <div className="row">
                                  <div className="col-6">
                                    <i>{ persona.name }</i>
                                  </div>
                                  <div className="col-6">
                                    <i>
                                      { 
                                        persona.cat_tipo_registro.tipo_registro.includes("Inicio") ?
                                        persona.cat_tipo_registro.tipo_registro.slice(7) 
                                        : persona.cat_tipo_registro.tipo_registro
                                      }
                                    </i>
                                    { 
                                      <FontAwesomeIcon icon={ faUserCheck } className={ "Icon-"+persona.cat_tipo_registro.tipo_registro } />
                                    }
                                    
                                  </div>
                                </div>
                                
                              </div>
                            </>
                        )
                        
                      })
                    }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </>
    );
  };